export default "__VITE_ASSET__CdJZpk7p__"